<template>
  <div id="app" class="min-h-screen bg-background text-foreground transition-colors duration-200">
    <transition-view name="fade" :duration="300">
      <router-view />
    </transition-view>
    
    <!-- Модальное окно предупреждения о сервере -->
    <server-warning-modal
      :visible="showServerWarning"
      :current-i-p="warningData.currentIP"
      :expected-i-p="warningData.expectedIP"
      :is-current-i-p="warningData.isCurrentIP"
      @close="hideServerWarning"
    />
  </div>
</template>

<script>
import TransitionView from './components/TransitionView.vue';
import ServerWarningModal from './components/ServerWarningModal.vue';
import { setEventBus } from './utils/server-check';
import { useTheme } from './utils/useTheme';

if (process.env.NODE_ENV === 'development') {
  import('./utils/server-check-test');
}

export default {
  name: 'App',
  components: {
    TransitionView,
    ServerWarningModal
  },
  setup() {
    const { loadTheme } = useTheme();
    loadTheme();
  },
  data() {
    return {
      showServerWarning: false,
      warningData: {
        currentIP: '',
        expectedIP: '178.66.50.117',
        isCurrentIP: true
      }
    }
  },
  created() {
    const eventBus = {
      emit: (event, data) => {
        if (event === 'show-server-warning') {
          this.warningData = data;
          this.showServerWarning = true;
        }
      }
    };
    
    setEventBus(eventBus);
  },
  methods: {
    hideServerWarning() {
      this.showServerWarning = false;
    }
  }
}
</script>

<style>
/* Глобальные стили будут импортированы из tailwind.css */
/* Добавим базовые стили для анимаций */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Глобальные стили для красивых скроллбаров */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: hsl(var(--muted));
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: hsl(var(--muted-foreground) / 0.6);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: hsl(var(--muted-foreground) / 0.8);
}
</style>
